"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornScreen = void 0;
var react_1 = __importDefault(require("react"));
var useFeedback_1 = require("../hooks/useFeedback");
var AcornScreenHeader_1 = require("./AcornScreenHeader");
var AcornScreen = function (props) {
    var titleElement = typeof props.title === 'string' ? react_1.default.createElement("h2", { className: "c-heading +h2" }, props.title) : props.title;
    var feedback = useFeedback_1.useFeedback();
    return (react_1.default.createElement("div", { className: "l-app +y u-min-height-1 +gap-0 l-acorn" },
        react_1.default.createElement("div", { className: "l-acorn__header" },
            react_1.default.createElement(AcornScreenHeader_1.AcornScreenHeader, __assign({}, props))),
        react_1.default.createElement("div", { className: "l-acorn__content" },
            react_1.default.createElement("div", { className: "cc-feedback-inpage" }, feedback.getFeedbackElements(useFeedback_1.CommonFeedbackPlacement.InPage)),
            props.children)));
};
exports.AcornScreen = AcornScreen;
//# sourceMappingURL=AcornScreen.js.map